export default __webpack_public_path__ + "static/media/red-circle.cb0592d5.svg";